module.exports = {"532822101":"勐海镇","532822102":"打洛镇","532822103":"勐混镇","532822104":"勐遮镇","532822105":"勐满镇","532822106":"勐阿镇","532822201":"勐宋乡","532822202":"勐往乡","532822203":"格朗和哈尼族乡","532822204":"布朗山布朗族乡","532822205":"西定哈尼族布朗族乡","532822401":"黎明农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532822.json
// module id = 2646
// module chunks = 0